/**
 * @module Section-Shared-ServicesStyle3
 */

import { TypeSectionServices } from "../../../@types/sectionTypes";
import { SECTION_THEME } from "../../../../globals/constants";
import { TypeService } from "../../../@types/reusableTypes";
import AvertImage from "../../../../globals/elements/avertimg";

/**
 * 
 * @param props : Data supplied to display services
 * @returns Markup for services section (style 3)
 */
const SectionSharedServicesStyle3 = (
    props: {
        _services: TypeSectionServices,
        _theme?: SECTION_THEME
    }
) => {
    const { _services, _theme } = props;
    var _sectionStyle = "site-bg-gray";

    if (_theme === SECTION_THEME.LIGHT) {
        _sectionStyle = "site-bg-white";
    }

    return (
        <div className={"section-full p-t120 p-b90 " + _sectionStyle + " av-serv-3-section-wrap wow fadeInDown"} data-wow-offset={100} data-wow-delay="0.2">
            <div className="container">
                <div className="section-content">
                    <div className="row">
                        {
                            _services.services.map((_item, _index) => {
                                return (
                                    <SectionSharedServicesStyle3Box key={_index} _data={_item} />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

/**
 * 
 * @param props : Data supplied to display single service box
 * @returns Markup for single service box (style 3)
 */
const SectionSharedServicesStyle3Box = (
    props: {
        _data: TypeService
    }
) => {
    const { _data } = props;
    return (
        <div className="col-lg-4 col-md-6 m-b30">
            <div className="av-icon-style-4-blocks">
                <div className="av-media">
                    <span><AvertImage src={_data.icon} alt="icon" /></span>
                </div>
                <div className="av-content">
                    <h3 className="av-title">{_data.title}</h3>
                    <p>{_data.subtitle}</p>
                </div>
            </div>
        </div>
    )
}

export default SectionSharedServicesStyle3;